import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { DonationGridObject, OkObject } from '@it2go/types';
import { DonationImportInput } from '@libs/types/src/chcrm/input-type/donation/donation-import.input';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { donationGridItemFrag } from '../../../services/types/donation.types';
import { DonationDeleteInput } from '@libs/types/src/chcrm/input-type/donation/donation-delete.input';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DonationGqlService extends GqlServiceV2 {

    public getDonations(input: GridInput | null) {
        return this.query<DonationGridObject>(
            `
                query($input: GridInput) {
                    donation {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${donationGridItemFrag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deleteDonation(input: DonationDeleteInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: DonationDeleteInput!) {
                    donation {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }

    public importDonationCsv(input: DonationImportInput) {
        return this.mutate<OkObject>(
            `
                mutation($input: DonationImportInput!) {
                    donation {
                        importCsv(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }
}
